import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
export const getCloudMigrationInfo = (mpacBaseUrl, appKey) => fetchOk("".concat(mpacBaseUrl, "/rest/2/addons/").concat(appKey, "/migration")).then(response => response.json()).catch(error => {
  if (error.status === 404) return null;
  throw error;
});